import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDOM from 'react-dom'
import configApp from './configApp'

import './scss/main.scss'
import './scss/mapbox-overrides/index.scss'

const configPromise = configApp()
const appPromise = import('./App/index')

async function startApp () {
  await configPromise
  const App = await appPromise

  ReactDOM.render(
    React.createElement(App.default),
    document.getElementById('root')
  )
}

startApp()
